import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import { Card } from '../../../components/Card';
import { CardField } from '../../../components/Card/CardField';
import { Repair } from '../../../data/Repair';

type RepairResultCardProps = {
    repair: Repair,
    onClick: () => void,
};

RepairResultCard.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        width: '100%',
        padding: theme.spacing(1),
    },
    button: {
        width: '100%',
    },
    fieldContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    status: {
        width: '100%',
        padding: theme.spacing(0.5, 1),
        borderRadius: 40,
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        color: '#AE5521',
        backgroundColor: '#EAE7E2',
    },
    completed: {
        color: '#187D55',
        backgroundColor: '#DAEAE9',
    },
    moreIconContainer: {
        marginTop: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.grey['700'],
        fontSize: 16,
    },
}));

function RepairResultCard(props: RepairResultCardProps): React.ReactElement {
    const {
        onClick,
        repair,
    } = props;
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <Card onClick={onClick} pointer>
                <div className={classes.fieldContainer}>
                    <CardField
                        label="產品型號"
                        value={repair.product_model_id}
                    />
                    <CardField
                        label="送修日期"
                        value={repair.repair_date}
                    />
                    <CardField
                        label="產品序號"
                        value={repair.sn_code_id}
                    />
                    <CardField
                        label="預計完修日"
                        value={repair.schedule_date}
                    />
                </div>
                <div className={clsx(classes.status, repair.stage_name_id === '維修中' ? classes.completed : null)}>
                    {repair.stage_name_id}
                </div>
                <div className={classes.moreIconContainer}>
                    <Icon icon={faChevronDown} />
                </div>
            </Card>
        </div>
    );
}

export { RepairResultCard };
